/*
 * @Auther: 罗耀祖
 * @Date: 2022-03-10 11:43:11
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-30 10:05:45
 * @name: 调用api方法
 * @Description: 调用api方法
 * @FilePath: \project\src\nestVue\common\decorators\Api.js
 * @Author: desktop
 */
import axios from "axios";
import api from "../api";
import defaultConfig from "@/nestVue/config/default.config";
import _ from "lodash";
import { Loading } from 'element-ui';
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 调用api方法
 * @param {String} route 调用的路由
 * @param {String} config 调用配置
 * @param {String} method 请求方式
 */
export function Api(route, config = {}, method = 'get') {
  return function (target, name, descriptor) {
    let oldValue = descriptor.value;
    descriptor.value = function (req) {
      return new Promise((resolve, reject) => {
        const url = target.ctx.module + '/' + route;
        // 放置请求体
        target.ctx.request.route = route;
        target.ctx.request.method = method;
        target.ctx.request.params = req;
        target.ctx.request.path = url;
        target.ctx.request.fullPath = process.env.VUE_APP_BASE_API + url;
        if (target.ctx.validator.code === 1) { //验证通过
          const instance = axios.create();
          let myConfig = JSON.parse(JSON.stringify(config));
          _.defaults(myConfig, defaultConfig); //合并自定义配置与默认配置
          const apiInstance = new api(myConfig);
          // 判断是否显示loading
          let loadingInstance;
          if (myConfig.showLoading) {
            loadingInstance = Loading.service();
          }
          apiInstance[method](url, req, instance).then(res => {
            target.ctx.response = res;
            oldValue.call(this, target.ctx);
            resolve(target.ctx);
          }).catch(err => {
            target.ctx.response = err;
            oldValue.call(this, target.ctx);
            reject(target.ctx);
          }).finally(() => {
            if (myConfig.showLoading) {
              loadingInstance.close();
            }
          });
        } else { //验证失败
          target.ctx.response = {};
          oldValue.call(this, target.ctx);
          reject(target.ctx);
        }
      })
    }
    return descriptor;
  }
}